import React from 'react';
import type { IconName } from '../../types/offer';
export type IconProps = {
  className?: string;
  strokeWidth?: number;
};
type BaseProps = IconProps & {
  children: React.ReactNode;
};
function Base({
  className = 'h-4 w-4',
  strokeWidth = 1.8,
  children
}: BaseProps) {
  return <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" data-id="element-129" data-mp="36htmxrcwyosv">
      {children}
    </svg>;
}
export function AlertIcon(props: IconProps) {
  return <Base {...props} data-id="element-130" data-mp="2il64px3j78g4">
      <path d="M10.6 3.6 2.5 17.4A1.6 1.6 0 0 0 3.9 20h16.2a1.6 1.6 0 0 0 1.4-2.6L13.4 3.6a1.6 1.6 0 0 0-2.8 0Z" data-id="element-131" data-mp="2ilpbchnqeaeu" />
      <path d="M12 9v4" data-id="element-132" data-mp="2nksiq8r6ospz" />
      <path d="M12 16.5h.01" data-id="element-133" data-mp="gryg1x213ehk" />
    </Base>;
}
export function ClockIcon(props: IconProps) {
  return <Base {...props} data-id="element-134" data-mp="ls4blobf5l4x">
      <circle cx="12" cy="12" r="9" data-id="element-135" data-mp="lq9pw7sbpozs" />
      <path d="M12 7v5l3 2" data-id="element-136" data-mp="lpi23j4ywvk2" />
    </Base>;
}
export function CheckIcon(props: IconProps) {
  return <Base {...props} data-id="element-137" data-mp="3og9ridlhb6lu">
      <path d="M20 6 9 17l-5-5" data-id="element-138" data-mp="3kharn7elu019" />
    </Base>;
}
export function CrossIcon(props: IconProps) {
  return <Base {...props} data-id="element-139" data-mp="23kx9szybfie">
      <circle cx="12" cy="12" r="9" data-id="element-140" data-mp="21qcceoojneb" />
      <path d="M15 9l-6 6M9 9l6 6" data-id="element-141" data-mp="24w1tv180rak" />
    </Base>;
}
export function CartIcon(props: IconProps) {
  return <Base {...props} data-id="element-142" data-mp="35js1q1q6xgs8">
      <circle cx="9" cy="20" r="1.4" data-id="element-143" data-mp="35j8k6m4gcueq" />
      <circle cx="18" cy="20" r="1.4" data-id="element-144" data-mp="35ka5djf6mxa6" />
      <path d="M2 3h2.6l2.5 12.1a1.8 1.8 0 0 0 1.8 1.4h8.9a1.8 1.8 0 0 0 1.8-1.4L21.5 7H6" data-id="element-145" data-mp="31i6js1ysucb6" />
    </Base>;
}
export function TrophyIcon(props: IconProps) {
  return <Base {...props} data-id="element-146" data-mp="3fj986ld9nyp9">
      <path d="M8 4h8v4a4 4 0 0 1-8 0V4Z" data-id="element-147" data-mp="3fflenm7tncaj" />
      <path d="M16 5h2.5a1.5 1.5 0 0 1 0 5H16M8 5H5.5a1.5 1.5 0 0 0 0 5H8" data-id="element-148" data-mp="3ahtiuh423612" />
      <path d="M12 12v4M9 20h6M10 20l.6-4M14 20l-.6-4" data-id="element-149" data-mp="ur7cjyijk8l3" />
    </Base>;
}
export function ShieldIcon(props: IconProps) {
  return <Base {...props} data-id="element-150" data-mp="prugcn5s5p5u">
      <path d="M12 21.5s7.5-4.2 7.5-10.3V5L12 2.5 4.5 5v6.2C4.5 17.3 12 21.5 12 21.5Z" data-id="element-151" data-mp="psdurtw81vf4" />
      <path d="M9 11.6l2.2 2.2L15.2 10" data-id="element-152" data-mp="xsseyt1vduf1" />
    </Base>;
}
export function HookIcon(props: IconProps) {
  return <Base {...props} data-id="element-153" data-mp="11x00yigy0w9k">
      <path d="M12 21V9" data-id="element-154" data-mp="16u06ms9vrx05" />
      <path d="M12 9a3.5 3.5 0 1 1 6-2.4" data-id="element-155" data-mp="16tqi794hhxwk" />
      <path d="M9.5 21h5" data-id="element-156" data-mp="16rx8fkykqxkc" />
    </Base>;
}
export function YarnIcon(props: IconProps) {
  return <Base {...props} data-id="element-157" data-mp="1br0e97mdp7td">
      <circle cx="11" cy="12" r="8" data-id="element-158" data-mp="e5cfig2gadeo" />
      <path d="M5 8.5c3.6 1 8.4 4.4 10.6 8.8M8 4.6C10.4 6.6 15.6 11 17.8 15.4M4.2 13.6C6.6 14 11 16.4 13 19.6" data-id="element-159" data-mp="e6du2uiodi15" />
      <path d="M19 20c1.6-.6 2.6-1.9 2.6-3.2" data-id="element-160" data-mp="j4yvgx9ny7r6" />
    </Base>;
}
export function StarIcon(props: IconProps) {
  return <Base {...props} data-id="element-161" data-mp="o1fitp91gi37">
      <path d="M12 3l2.4 6.2 6.6.5-5 4.3 1.5 6.5L12 17.1 6.5 20.5 8 14 3 9.7l6.6-.5L12 3Z" data-id="element-162" data-mp="su8ocfcbzugc" />
    </Base>;
}
export function SparkIcon(props: IconProps) {
  return <Base {...props} data-id="element-163" data-mp="3rjz3a5lh6jng">
      <path d="M12 3v5M12 16v5M4.5 12h5M14.5 12h5" data-id="element-164" data-mp="3rieg511hq2zm" />
      <path d="M7 7l2.5 2.5M14.5 14.5 17 17M17 7l-2.5 2.5M9.5 14.5 7 17" data-id="element-165" data-mp="cmvgh6hfik7" />
    </Base>;
}
export function ArrowDownIcon(props: IconProps) {
  return <Base {...props} data-id="element-166" data-mp="3k0q2v1uy5vaj">
      <path d="M12 4v15" data-id="element-167" data-mp="3k0gcve9wjo4u" />
      <path d="M6 13.5 12 20l6-6.5" data-id="element-168" data-mp="3k214ow4u0sz0" />
    </Base>;
}
export function ArrowRightIcon(props: IconProps) {
  return <Base {...props} data-id="element-169" data-mp="3ezseg7jcg50l">
      <path d="M4 12h15" data-id="element-170" data-mp="3a2k4gu8cn7af" />
      <path d="M13.5 6l6 6-6 6" data-id="element-171" data-mp="3a320bpr3njht" />
    </Base>;
}
export function PdfIcon(props: IconProps) {
  return <Base {...props} data-id="element-172" data-mp="3616uq924yjy8">
      <path d="M6 2.5h8l4 4v15H6z" data-id="element-173" data-mp="362i0gef561rz" />
      <path d="M14 2.5v4h4" data-id="element-174" data-mp="362rovxkjg0vk" />
      <path d="M9 12h6M9 16h4" data-id="element-175" data-mp="319oz80ivtbkn" />
    </Base>;
}
export function RefundIcon(props: IconProps) {
  return <Base {...props} data-id="element-176" data-mp="2wac6x098rcao">
      <path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" data-id="element-177" data-mp="2wbncn5m8yu4f" />
      <path d="M3 4.5V10h5.5" data-id="element-178" data-mp="2rcarcpb0xv3y" />
      <path d="M12 9v6M10 11h3a1.5 1.5 0 0 1 0 3h-3" data-id="element-179" data-mp="2rd3ocyk6l68w" />
    </Base>;
}
export function QuestionIcon(props: IconProps) {
  return <Base {...props} data-id="element-180" data-mp="2mc67cpawqi8z">
      <circle cx="12" cy="12" r="9" data-id="element-181" data-mp="2ibcls2kxtfj9" />
      <path d="M9.6 9.4a2.5 2.5 0 1 1 3.6 2.2c-.8.5-1.2 1-1.2 1.9" data-id="element-182" data-mp="2icfb462m39x2" />
      <path d="M12 17h.01" data-id="element-183" data-mp="372a6j9n08dez" />
    </Base>;
}
export function LockOpenIcon(props: IconProps) {
  return <Base {...props} data-id="element-184" data-mp="3c0ttnddc3v8x">
      <rect x="4.5" y="10.5" width="15" height="10" rx="2" data-id="element-185" data-mp="3c01wvz803rh2" />
      <path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 6.9-.8" data-id="element-186" data-mp="2y9oqw2eo6mud" />
      <path d="M12 14.5v2.5" data-id="element-187" data-mp="2y8x5tlip87ic" />
    </Base>;
}
export function ChartUpIcon(props: IconProps) {
  return <Base {...props} data-id="element-188" data-mp="329quih3ytqca">
      <path d="M4 20V4" data-id="element-189" data-mp="3297cz1i893ys" />
      <path d="M4 20h16" data-id="element-190" data-mp="2obsfralqfrw9" />
      <path d="M7.5 15.5 11 11l3 2.5L19.5 7" data-id="element-191" data-mp="2oahbl9odki4m" />
      <path d="M15.5 7h4v4" data-id="element-192" data-mp="2odvhgrw8z9gt" />
    </Base>;
}
export function VaultIcon(props: IconProps) {
  return <Base {...props} data-id="element-193" data-mp="2t896mckbgkd1">
      <rect x="3" y="4" width="18" height="16" rx="2.5" data-id="element-194" data-mp="2fbcfsb4772w5" />
      <circle cx="12" cy="12" r="4" data-id="element-195" data-mp="2fcxac0qiilu0" />
      <path d="M12 8V6.5M12 17.5V16M8 12H6.5M17.5 12H16" data-id="element-196" data-mp="2jc66tdcxsxt9" />
    </Base>;
}
export function BearIcon(props: IconProps) {
  return <Base {...props} data-id="element-197" data-mp="dksnh3nveeq5">
      <circle cx="12" cy="13.5" r="6" data-id="element-198" data-mp="dk919ar6t46b" />
      <circle cx="6.5" cy="7.5" r="2.8" data-id="element-199" data-mp="hkszkhnhydu1" />
      <circle cx="17.5" cy="7.5" r="2.8" data-id="element-200" data-mp="hkj8eqqpu0mr" />
      <path d="M10 13h.01M14 13h.01" data-id="element-201" data-mp="2233jwdkqa9xb" />
      <path d="M10.5 16.2c.9.7 2.1.7 3 0" data-id="element-202" data-mp="224553avgkcsr" />
    </Base>;
}
export function SearchIcon(props: IconProps) {
  return <Base {...props} data-id="element-203" data-mp="1y336mw9d84ru">
      <circle cx="11" cy="11" r="6.5" data-id="element-204" data-mp="1xzfd3x3x7id4" />
      <path d="M16 16l4.5 4.5" data-id="element-205" data-mp="2btg94j3hmr9s" />
    </Base>;
}
export function CalculatorIcon(props: IconProps) {
  return <Base {...props} data-id="element-206" data-mp="2715cbp41nllg">
      <rect x="5" y="2.5" width="14" height="19" rx="2.5" data-id="element-207" data-mp="270na8bupad5m" />
      <path d="M8.5 7h7" data-id="element-208" data-mp="2lqkysswjl4vc" />
      <path d="M9 12h.01M12 12h.01M15 12h.01M9 16.5h.01M12 16.5h.01M15 16.5h.01" data-id="element-209" data-mp="2lprppla423a1" />
    </Base>;
}
export function VideoIcon(props: IconProps) {
  return <Base {...props} data-id="element-210" data-mp="2uriwktge0g5h">
      <rect x="3" y="5.5" width="12.5" height="13" rx="2.5" data-id="element-211" data-mp="2us11sfl124pj" />
      <path d="M15.5 10.5 21 7.5v9l-5.5-3z" data-id="element-212" data-mp="2psoexuu5oxmy" />
    </Base>;
}
export function TagIcon(props: IconProps) {
  return <Base {...props} data-id="element-213" data-mp="10di18ik1qba5">
      <path d="M11.5 3H20a1 1 0 0 1 1 1v8.5a1 1 0 0 1-.3.7l-7.8 7.8a1 1 0 0 1-1.4 0l-8.3-8.3a1 1 0 0 1 0-1.4l7.8-7.8a1 1 0 0 1 .7-.3Z" data-id="element-214" data-mp="10et1i8ea90wi" />
      <circle cx="16.5" cy="7.5" r="1.6" data-id="element-215" data-mp="vgrj7pool5m3" />
    </Base>;
}
export function LicenseIcon(props: IconProps) {
  return <Base {...props} data-id="element-216" data-mp="30fzlrrfmt714">
      <rect x="3" y="4.5" width="18" height="12" rx="2" data-id="element-217" data-mp="30fhi49qn3qj6" />
      <path d="M7 9h5M7 12.5h3" data-id="element-218" data-mp="30i3pa89mc40v" />
      <circle cx="17" cy="11" r="2" data-id="element-219" data-mp="35fcakhq2co6c" />
      <path d="M14.8 20.5 17 18.8l2.2 1.7-.8-3.3" data-id="element-220" data-mp="35easvuejl3fn" />
    </Base>;
}
export function RoadmapIcon(props: IconProps) {
  return <Base {...props} data-id="element-221" data-mp="39el17dpt45xo">
      <path d="M6 3v13" data-id="element-222" data-mp="3eg2053oqdibm" />
      <path d="M6 4.5c3-2 6 2 9 0v6c-3 2-6-2-9 0" data-id="element-223" data-mp="3egk2mi1zksrz" />
      <circle cx="6" cy="19.5" r="1.6" data-id="element-224" data-mp="3edxykseb0vei" />
    </Base>;
}
export function ArrowLeftIcon(props: IconProps) {
  return <Base {...props} data-id="element-225" data-mp="3o5txg5o7spjs">
      <path d="M20 12H5" data-id="element-226" data-mp="3o5btsnz8391u" />
      <path d="M10.5 6l-6 6 6 6" data-id="element-227" data-mp="3o63qk24k3ctp" />
    </Base>;
}
export function QuoteIcon(props: IconProps) {
  return <Base {...props} data-id="element-228" data-mp="3t3vfqodtgku7">
      <path d="M9.5 6.5C6.9 7.6 5 10.2 5 13.2c0 2.2 1.4 3.8 3.3 3.8 1.7 0 3-1.2 3-2.9 0-1.6-1.1-2.8-2.7-2.8-.3 0-.6 0-.8.1.4-1.4 1.4-2.6 2.7-3.3Z" data-id="element-229" data-mp="3t6hmilsvuwbd" />
      <path d="M18.5 6.5C15.9 7.6 14 10.2 14 13.2c0 2.2 1.4 3.8 3.3 3.8 1.7 0 3-1.2 3-2.9 0-1.6-1.1-2.8-2.7-2.8-.3 0-.6 0-.8.1.4-1.4 1.4-2.6 2.7-3.3Z" data-id="element-230" data-mp="610f7znzy4ku" />
    </Base>;
}
export function PinIcon(props: IconProps) {
  return <Base {...props} data-id="element-231" data-mp="1lhlk83qz30u8">
      <path d="M12 21.5s6.5-6 6.5-11a6.5 6.5 0 1 0-13 0c0 5 6.5 11 6.5 11Z" data-id="element-232" data-mp="1ll9fb7c2fvb2" />
      <circle cx="12" cy="10.5" r="2.4" data-id="element-233" data-mp="1hhl7cnjiuxpa" />
    </Base>;
}
export function CameraIcon(props: IconProps) {
  return <Base {...props} data-id="element-234" data-mp="1ckl38i68g50t">
      <rect x="3" y="6" width="18" height="14" rx="3.5" data-id="element-235" data-mp="29894loi2rixo" />
      <circle cx="12" cy="13" r="3.6" data-id="element-236" data-mp="297pmo7sfcujn" />
      <path d="M17 9.5h.01" data-id="element-237" data-mp="2575p533xvowz" />
      <path d="M8.5 6l1.3-2.2h4.4L15.5 6" data-id="element-238" data-mp="257ytxyjc84ch" />
    </Base>;
}
export function StoreIcon(props: IconProps) {
  return <Base {...props} data-id="element-239" data-mp="20emby795yvsp">
      <path d="M3.5 9.5h17V20a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V9.5Z" data-id="element-240" data-mp="20duhizraz440" />
      <path d="M3 9.5 5 4h14l2 5.5" data-id="element-241" data-mp="1vgkwdway5elz" />
      <path d="M9.5 21v-6h5v6" data-id="element-242" data-mp="2swhxy1vctuyr" />
    </Base>;
}
export function VerifiedIcon(props: IconProps) {
  return <Base {...props} data-id="element-243" data-mp="2o61m2m76mhei">
      <path d="M12 2.5l2.3 1.7 2.8-.2 1 2.7 2.4 1.5-.9 2.7.9 2.7-2.4 1.5-1 2.7-2.8-.2L12 19.3l-2.3-1.7-2.8.2-1-2.7L3.5 13.6l.9-2.7-.9-2.7 2.4-1.5 1-2.7 2.8.2L12 2.5Z" data-id="element-244" data-mp="2o5hzutai16uo" />
      <path d="M9 11.8l2.2 2.2 3.9-4" data-id="element-245" data-mp="218x2uu7p1698" />
    </Base>;
}
export function EyeIcon(props: IconProps) {
  return <Base {...props} data-id="element-246" data-mp="1mkj2cpxr1tvu">
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" data-id="element-247" data-mp="1ml27f62awnsg" />
      <circle cx="12" cy="12" r="3" data-id="element-248" data-mp="1ric7dfnbghuj" />
    </Base>;
}
export function XIcon(props: IconProps) {
  return <Base {...props} data-id="element-249" data-mp="2f9pzpllgwdfi">
      <path d="M6 6l12 12M18 6 6 18" data-id="element-250" data-mp="2f97sxv16igtc" />
    </Base>;
}
export const iconMap: Record<IconName, (props: IconProps) => React.ReactElement> = {
  vault: VaultIcon,
  amigurumi: BearIcon,
  search: SearchIcon,
  calculator: CalculatorIcon,
  video: VideoIcon,
  tag: TagIcon,
  license: LicenseIcon,
  roadmap: RoadmapIcon
};